import { ContractConceptRelationship } from "../../../models/Entities/Contracts/ContractConceptRelationship";
import { HCVisit } from "../../../models/Entities/Protocols/HCVisit";

// store
import * as ConceptRelationshipStore from '../../../redux/middleware/ContractConceptRelationship.Middleware';
import * as PractitionerStore from '../../../redux/middleware/PractitionerMiddleware';
import { Practitioner } from '../../../models/Entities/Practitioners/Practitioner';
import { AppState } from "../../../redux/reducers";

interface IProps {
    visit: HCVisit;
    ContractId: number; // Assuming ContractId is needed for the modal
}
  
interface ConnectedProps {
    isLoaging: boolean;
    isSaving: boolean;
    isDeleting: boolean;
    ConceptRelationships: ContractConceptRelationship[];
    /** Para mostrar quién completó cada formulario (ids de usuario del EMR → nombre). */
    practitioners: Practitioner[];
    practitionersLoaded: boolean;
}
  
  interface DispatchProps {
    getAllContractConceptRelationships: typeof ConceptRelationshipStore.actionCreators.getAllContractConceptRelationships;
    GetAllPractitioners: typeof PractitionerStore.actionCreators.GetAllPractitioners;
  }
  
  export type Props = IProps & ConnectedProps & DispatchProps;
  
  export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    isLoaging: state.ContractConceptRelationship?.isLoadingAll || false,
    isSaving: state.ContractConceptRelationship?.isAddingNewOne || false,
    isDeleting: state.ContractConceptRelationship?.isDeletingOne || false,
    ConceptRelationships: state.ContractConceptRelationship?.list || [],
    practitioners: state.Practitioners?.list || [],
    practitionersLoaded: !!state.Practitioners?.successLoadingAll || (state.Practitioners?.list?.length ?? 0) > 0
  });

  export const mapDispatchToProps = {
    ...ConceptRelationshipStore.actionCreators,
    GetAllPractitioners: PractitionerStore.actionCreators.GetAllPractitioners
  };